export default "__VITE_ASSET__BaJi0sSU__"